import React from 'react'
import { LoadingComponent } from '@pga/pga-component-library'

export default ({ isLoading }) => isLoading ? <LoadingComponent data-testid='loading-component' /> : null
